module.exports = __webpack_public_path__ + "img/vmc_aniv11_24Aug2021.cf728eca.jpg";